import React from 'react';
import { useRecoilValue } from 'recoil';
import { CardBody } from '../../components/CardBody';
import { CardHeader } from '../../components/CardHeader';

import { allProductsState } from '../../recoil/atoms';
import { assetPathFn } from '../../util';
import { ShopNowCardFooter, ShopNowCardSection } from '../HomeLander/HomeLanderMobile';
import { HeroCallout } from '../HeroCallout';
import { WistiaPanel } from '../../components/WistiaPanel';
import { NewsIcons } from '../../product_detail/components/NewsIcons';
import { ShopAllColors } from '../components/ShopAllColors';
import { ProductFeatures } from '../components/ProductFeatures';
import { LanderTopHero } from '../components/LanderTopHero';
import { ProductHandle } from '../../enums/ProductHandle.enum';
import { CardFooter } from '../../components/CardFooter';
import styles from './LiftWearTankLanderMobile.module.scss';
import { useLanderControls } from '../LanderContext';

export const LiftWearTankLanderMobile: React.FC = () => {
  const allProducts = useRecoilValue(allProductsState);
  const { scrollToProductSection } = useLanderControls();

  const wistiaVideoId = 'txjj1yry1r';
  const padding = { padding: '145.0% 0 0 0' };
  return (
    <>
      <CardBody>
        <LanderTopHero
          heroImage={'mobile-liftwear-tank-lander-top-hero-1.png'}
          title={'LiftWear Tank'}
          subTitle={`Meet the world's smartest Tank.`}
          backgroundColor={'#E2E2E2'}
        >
          <HeroCallout
            orderIndex={0}
            label={
              <>
                Soft <br />
                removable
                <br /> cups
              </>
            }
            titleStyles={{ marginTop: -4, lineHeight: '22px' }}
            inlineStyles={{
              mobile: {
                right: `39.5%`,
                top: `32%`,
                flexDirection: 'row-reverse',
                alignItems: 'flex-start',
              },
            }}
          />
          <HeroCallout
            orderIndex={1}
            label={<>Wire-free lift</>}
            titleStyles={{ lineHeight: '22px' }}
            inlineStyles={{
              mobile: {
                right: `3%`,
                top: `39%`,
                flexDirection: 'row-reverse',
              },
            }}
          />
          <HeroCallout
            orderIndex={2}
            label={
              <>
                Targeted <br />
                Compression
              </>
            }
            titleStyles={{ lineHeight: '22px' }}
            inlineStyles={{
              mobile: {
                right: `27%`,
                top: `58%`,
                flexDirection: 'row-reverse',
              },
            }}
          />
        </LanderTopHero>
      </CardBody>
      <ShopNowCardFooter onClick={scrollToProductSection} />
      <CardHeader />
      <CardBody>
        <NewsIcons />
        <ProductFeatures
          features={[
            {
              imgName: 'feature-lwt-desktop-1.jpg',
              title: 'Underwire-free lift',
              description: 'Molded cups and bonding at the cradle lifts your chest for a supportive, comfortable fit.',
            },
            {
              imgName: 'feature-lwt-desktop-2.jpg',
              title: 'Targeted smoothing',
              description: 'Targeted X-shaped panel on the interior hugs your midsection for extra waist shaping.',
            },
            {
              imgName: 'feature-lwt-desktop-3.jpg',
              title: 'No back bulge',
              description: 'A second layer of smoothing fabric at the upper back eliminates bulging.',
            },
          ]}
        />
        <div className={styles.comparison}>
          <img src={assetPathFn('liftwear-short-before-after.jpg')} alt="comparison" />
          <div>
            <div>competitor</div>
            <div>Liftwear</div>
          </div>
        </div>
        <ShopNowCardSection onClick={scrollToProductSection} />
        <WistiaPanel videoId={wistiaVideoId} responsivePadding={padding} />
        <ShopAllColors product={allProducts[ProductHandle.LiftWearTank]} />
      </CardBody>
      <CardFooter />
    </>
  );
};

export default LiftWearTankLanderMobile;
